import { Component, Input } from '@angular/core';

import { NewCharitySummaryData } from '../add-charity.model';

@Component({
  selector: 'app-add-charity-summary',
  templateUrl: './add-charity-summary.component.html',
  styleUrls: ['./add-charity-summary.component.scss'],
  standalone: false,
})
export class AddCharitySummaryComponent {
  @Input() displayData: NewCharitySummaryData;
}
